import { NgModule } from '@angular/core';
import { CamelCaseToDashPipe, DashToTitle } from './camelCaseToDash.pipe';
import { FromNowPipe } from './from-now.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { EntriesPipe, KeysPipe } from './keys.pipe';
import { SvgIconUrlPipe } from './svgIconUrl.pipe';
import { AblePipe } from './able.pipe';

const pipes = [
  CamelCaseToDashPipe,
  DashToTitle,
  EntriesPipe,
  GetByIdPipe,
  HtmlToPlaintextPipe,
  KeysPipe,
  SvgIconUrlPipe,
  FromNowPipe,
  AblePipe
];

// const modules = [
//   CamelCaseToDashPipe,
//   DashToTitle,
//   EntriesPipe,
//   GetByIdPipe,
//   HtmlToPlaintextPipe,
//   KeysPipe,
//   SvgIconUrlPipe,
//   FromNowPipe,
// ];
@NgModule({imports: pipes,  
  exports: pipes,  })
export class NkPipesModule {}
